export default {
  menu: 'Starta test',
  welcome: 'Välkommen!',
  lead: 'Du är nu på väg att göra följande test:',
  continue: 'Gå vidare',
  introduction_1:
    'Det är viktigt att du besvarar testet själv utan hjälp från andra. Försäkra dig om att du kan arbeta ostört. Det är inte tillåtet att kopiera och/eller sprida någon del av testet.',
  introduction_2: 'För att fortsätta, klicka på Gå vidare-knappen.',
  introduction_3: 'Jag har läst integritetspolicyn och accepterar den.',
  register: 'Registrera',
  first_name: 'Förnamn',
  last_name: 'Efternamn',
  age: 'Ålder',
  application: 'Sökt tjänst',
  current: 'Nuvarande tjänst',
  gender: 'Kön'
}
